import { backendApi } from '@app/services'
import { isTextLinkyfied } from '@app/utils'

import { LinkPreview } from './types'
import { OpenGraphApiResponse } from '../../../../api/src/api/preview/types'

export const getPreviewContent = async (
  link: string
): Promise<LinkPreview | null> => {
  if (!link) {
    return null
  }

  if (!isTextLinkyfied(link)) {
    return null
  }

  try {
    const { data } = await backendApi.post<OpenGraphApiResponse>('/preview', {
      content: link,
    })

    const image =
      data?.openGraph?.image?.url ||
      data?.hybridGraph?.imageSecureUrl ||
      data?.hybridGraph?.image

    const imageUrl = image?.includes('.listglobally.com')
      ? image?.replace('?fit=fill&w=800&h=420', '')
      : image

    const title = data?.openGraph?.title || data?.hybridGraph?.title
    const subTitle =
      data?.openGraph?.description || data?.hybridGraph?.description

    if (!title && !subTitle && !imageUrl) {
      return null
    }

    return {
      imageUrl,
      subTitle,
      title,
    }
  } catch (error) {
    console.warn('Failed to load preview content', { link, error })
    return null
  }
}
